import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import Sidebar from './components/Sidebar';
import { Button, FormControlLabel, Grid, Radio, RadioGroup, Typography } from '@mui/material';
import i18next from 'i18next';
import imgurl from './assests/images/imgurl';
import { useDispatch, useSelector } from 'react-redux';
import { clearImagesInRedux, gTagTracking, serviceDown, trackEvent } from './utils/UtilityFunctions';
import AlertComp from './Alert';
import MainLoader from './components/MainLoader';
import { postApi } from './api/services';

const Preview = () => {

  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()
  const [isMobile, setIsMobile] = useState(false);
  const [alertopen, setalertopen] = useState(false)
  const [alertmsg, setalertmsg] = useState('analyze')
  const [radioValue, setRadioValue] = useState('yes')
  const [gender, setGender] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  let { Topview, Leftview, Rightview, Frontview, Gender } = useSelector((state) => state.user.profile);

  const channel = localStorage.getItem('channel')

  useEffect(() => {
    if(Gender == ''){
      setGender(localStorage.getItem('gender'))
    } else {
      setGender(Gender)
    }
  }, [])

  useEffect(() => {
    if (!window.cordova) {
      let isMobile = /iPhone|iPod|Android/i.test(navigator.userAgent);
      if (!isMobile) {
        setIsMobile(false);
      } else {
        setIsMobile(true);
      }
    }
  }, []);

  const handleRadioChange = async (value) => {
    try{
      setRadioValue(value) 
      await trackEvent('face_covered', 'success', '', localStorage.getItem('phno')) 
      await gTagTracking('face_covered', {
        action: 'success',
        error: '',
        mobile_number: localStorage.getItem('phno')
      })
    } catch (err) {
      await trackEvent('face_covered', 'fail', err, localStorage.getItem('phno')) 
      await gTagTracking('face_covered', {
        action: 'fail',
        error: err,
        mobile_number: localStorage.getItem('phno')
      })
    }
  }

  const getResult = async () => {
    const userObj = JSON.parse(localStorage.getItem('user_obj'))
    try{
      if(radioValue == 'no'){
        setalertmsg(i18next.t('Your face is not covered properly, please retake'))
        setalertopen(true)
      } else {
        if (Topview != '' && Frontview != '' && Rightview != '' && Leftview != '' && gender.toUpperCase() == "MALE") {
          await trackEvent('analyze_button_clicked', 'success', '', localStorage.getItem('phno'), userObj.user_id) 
          await gTagTracking('analyze_button_clicked', {
            action: 'success',
            error: '',
            mobile_number: localStorage.getItem('phno'),
            user_id: userObj.user_id
          })
          // navigate('/reports', {state: {from: 'previewTest'}})
          // navigate('/loginpage')
          sendReport()
        } else if (Topview != '' && Frontview != '' && gender.toUpperCase() == "FEMALE") {
          await trackEvent('analyze_button_clicked', 'success', '', localStorage.getItem('phno'), userObj.user_id) 
          await gTagTracking('analyze_button_clicked', {
            action: 'success',
            error: '',
            mobile_number: localStorage.getItem('phno'),
            user_id: userObj.user_id
          })
          // navigate('/reports', {state: {from: 'previewTest'}})
          // navigate('/loginpage')
          sendReport()
        }  else {
          setalertmsg('Please provide all images.')
          setalertopen(true)
          setTimeout(() => {
            setalertopen(false)
          }, 4000);
        }
      } 
    } catch (err) {
      console.log("err", err);
      await trackEvent('analyze_button_clicked', 'fail', err, localStorage.getItem('phno'), userObj.user_id) 
      await gTagTracking('analyze_button_clicked', {
        action: 'fail',
        error: err,
        mobile_number: localStorage.getItem('phno'),
        user_id: userObj.user_id
      })
    }
  }

  const sendReport = async () => {
    let genderVal = localStorage.getItem('gender') ? localStorage.getItem('gender') : 'male'
    let userObj = JSON.parse(localStorage.getItem('user_obj'))
    let imgObj = genderVal.toUpperCase() == "MALE" ?
        {
          front_img: Frontview,
          top_img: Topview,
          left_img: Leftview,
          right_img: Rightview,
        } : 
        {
          front_img: Frontview,
          top_img: Topview,
        }
    setIsLoading(true)
    try {
      let params = {
        image_data: imgObj,
        userid: userObj.user_id,
        channel: window.cordova ? "mobile" : "webapp",
        website_source : localStorage.getItem('channel') ? localStorage.getItem('channel') : ''
      };
      console.log("predict_all params", params);
      let res = await postApi('predict_all', params)
      console.log("predict_all res", res);
      setIsLoading(false)
      if(res?.error) {
        await trackEvent('test_submitted', 'fail', res.error, localStorage.getItem('phno'), userObj.user_id)
        await gTagTracking('test_submitted', {
          action: 'fail',
          error: res.error,
          mobile_number: localStorage.getItem('phno'),
          user_id: userObj.user_id
        })
        serviceDown(navigate, '/taketest')
      } else {
        await trackEvent('test_submitted', 'success', '', localStorage.getItem('phno'), userObj.user_id)
        await gTagTracking('test_submitted', {
          action: 'success',
          error: '',
          mobile_number: localStorage.getItem('phno'),
          user_id: userObj.user_id
        })
        navigate('/loginpage', {state: {analysis_id: res.analysis_id}})
      }
    } catch (err) {
      console.log("err", err);
      setIsLoading(false)
      await trackEvent('test_submitted', 'fail', err, localStorage.getItem('phno'), userObj.user_id)
      await gTagTracking('test_submitted', {
        action: 'fail',
        error: err,
        mobile_number: localStorage.getItem('phno'),
        user_id: userObj.user_id
      })
      serviceDown(navigate, '/taketest')
    }
  };

  const handleRetake = () => {
    if(((Frontview && Rightview && Leftview && Topview) && gender.toUpperCase() === "MALE") || 
      ((Frontview && Topview) && gender.toUpperCase() === "FEMALE")
    ){
      swal({
        title: i18next.t('Do you want to discard captured photos?'),
        buttons: {
          cancel: {
            text: i18next.t("No"),
            value: false,
            visible: true,
          },
          confirm: {
            text: i18next.t("Yes"),
            value: true,
            visible: true,
          },
        },
        className: "multiple-button-swal",
      }).then((val) => {
        if(val){  
          clearImagesInRedux(dispatch)
          navigate('/taketest', {state: {goTo: 'aloxa'}})
        }
      })
    }  
  }

  return (
    <>
      { isLoading && <MainLoader /> }
      <div className='previewpage photo-container main-section-container'>
        <Grid container spacing={0} className='d-flex justify-content-start align-items-center'>
          <Grid item xs={1} className=''>
            <div className='d-flex justify-content-start align-items-center'>
              <span className='backButtonDiv' onClick={() => navigate(-1, { state: { goTo: location?.state?.from }})}>
                <ArrowBackOutlinedIcon className='arrowBackBtn'></ArrowBackOutlinedIcon>
              </span>
            </div>
          </Grid>
          <Grid item xs={11} className='d-flex justify-content-center align-items-center'>
            <Typography variant="h6" className="title">{i18next.t("Preview")}</Typography>
          </Grid>
          {/* <Grid item xs={1} className='d-flex justify-content-center align-items-center'>
            <Sidebar/>
          </Grid> */}
        </Grid>
        <div className='preview-page-container'>
          {
            gender?.toUpperCase() === "MALE" ? 
            <>
              <Grid container spacing={0} className='d-flex justify-content-start align-items-center'>
                <Grid item xs={6} className='photocontainer'>
                  <div className='photo-div'>
                    <img className={isMobile ? 'clickedphoto mobile' : 'clickedphoto'} src={Frontview ? `data:image/jpeg;base64,${Frontview}` : imgurl.frontImgPrev}/>
                  </div>
                </Grid>
                <Grid item xs={6} className='photocontainer'>
                  <div className='photo-div'>
                    <img className={isMobile ? 'clickedphoto mobile' : 'clickedphoto'} src={Rightview ? `data:image/jpeg;base64,${Rightview}` : imgurl.leftImgPrev}/>
                  </div>
                </Grid>
              </Grid>
              <Grid container spacing={0} className='d-flex justify-content-start align-items-center'>
                <Grid item xs={6} className='photocontainer'>
                  <div className='photo-div'>
                    <img className={isMobile ? 'clickedphoto mobile' : 'clickedphoto'} src={Leftview ? `data:image/jpeg;base64,${Leftview}` : imgurl.rightImgPrev}/>
                  </div>
                </Grid>
                <Grid item xs={6} className='photocontainer'>
                  <div className='photo-div'>
                    <img className={isMobile ? 'clickedphoto mobile' : 'clickedphoto'} src={Topview ? `data:image/jpeg;base64,${Topview}` : imgurl.topImgPrev}/>
                  </div>
                </Grid>
              </Grid>
            </>
              : 
            <>
              <Grid container spacing={0} className='d-flex justify-content-start align-items-center'>
                <Grid item xs={12} className='photocontainer'>
                  <div className='photo-div'>
                    <img className={isMobile ? 'clickedphoto mobile female' : 'clickedphoto female'} src={Frontview ? `data:image/jpeg;base64,${Frontview}` : imgurl.frontImgPrev}/>
                  </div>
                </Grid>
                <Grid item xs={12} className='photocontainer'>
                  <div className='photo-div'>
                    <img className={isMobile ? 'clickedphoto mobile female' : 'clickedphoto female'} src={Topview ? `data:image/jpeg;base64,${Topview}` : imgurl.topImgPrev}/>
                  </div>
                </Grid>
              </Grid>
            </>
          }
          {/* <Grid item xs={12} className='pt-0px mt-10px mb-10px'>
            <div className='questionsSectionDiv'>
              <Typography>{i18next.t("Is your face covered?")}</Typography>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue={radioValue}
                name="radio-buttons-group"
                onChange={(e) => handleRadioChange(e.target.value)}
              >
                <FormControlLabel value="yes" control={<Radio />} label={i18next.t("Yes")} />
                <FormControlLabel value="no" control={<Radio />} label={i18next.t("No")} /> 
              </RadioGroup>  
            </div>
          </Grid> */}
          <AlertComp open={alertopen} msg={alertmsg} type={"error"} />
        </div>
        <Grid container spacing={0} className='pt-0px mt-20px preview-btn-holdermain'>
          <Grid xs={12} className='preview-btn-container'>
            <Button
              className='retakeBtn'
              onClick={() => handleRetake()}
            >
              {i18next.t("Retake")}
            </Button>
          </Grid>
          <Grid xs={12} className='preview-btn-container'>
            <Button
              className='AnalyzeButton'
              onClick={() => getResult()}
            >
              {i18next.t("Proceed")}
            </Button>
          </Grid>
        </Grid>
      </div>
    </>
  )
}

export default Preview